import { useParams, useNavigate } from "react-router-dom";
import { useState } from "react";
import "./ProductDetail.css";

const ProductDetail = ({ products = [], addToCart }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [quantity, setQuantity] = useState(1);

  const product = products.find((p) => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="product-detail-error">
        <p>Prodotto non trovato</p>
        <button onClick={() => navigate("/products")}>Torna ai Prodotti</button>
      </div>
    );
  }

const handleAddToCart = () => {
  addToCart({ ...product, quantity });
  alert(`${quantity} x ${product.name} aggiunto al carrello!`);
  setQuantity(1);
};

  return (
    <div className="product-detail">
      <button className="back-button" onClick={() => navigate("/products")}>
        ← Indietro
      </button>

      <div className="product-detail-container">
        <div className="product-detail-image">
          <img src={product.image} alt={product.name} className="product-detail-img" />
          {product.discount > 0 && (
            <div className="discount-badge">-{product.discount}%</div>
          )}
        </div>

        <div className="product-detail-info">
          <h1>{product.name}</h1>

          <div className="product-rating-detail">
            <div className="stars-large">★★★★★ {(product.reviews / 50).toFixed(1)}</div>
            <span className="reviews-link">
              ({product.reviews} clienti soddisfatti)
            </span>
          </div>

          <div className="price-section">
            <span className="current-price">€{product.price.toFixed(2)}</span>
            {product.discount > 0 && (
              <span className="save-amount">
                Risparmi €{(product.price * product.discount / 100).toFixed(2)}
              </span>
            )}
          </div>

          <div className="stock-info">
            {product.stock > 0 ? (
              <p className="in-stock-detail">✓ {product.stock} disponibili in magazzino</p>
            ) : (
              <p className="out-of-stock-detail">Non disponibile</p>
            )}
          </div>

          <p className="product-description-detail">{product.description}</p>

          <div className="add-to-cart-section">
            <div className="quantity-selector">
              <label htmlFor="quantity">Quantità:</label>
              <button
                onClick={() => setQuantity(Math.max(1, quantity - 1))}
                className="qty-btn"
              >
                −
              </button>
              <input
                id="quantity"
                type="number"
                min="1"
                max={product.stock}
                value={quantity}
                onChange={(e) =>
                  setQuantity(Math.min(product.stock, Math.max(1, parseInt(e.target.value) || 1)))
                }
                className="qty-input"
              />
              <button
                onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                className="qty-btn"
              >
                +
              </button>
            </div>

            <button
              className="add-to-cart-btn-large"
              onClick={handleAddToCart}
              disabled={product.stock === 0}
            >
              🛒 Aggiungi al Carrello
            </button>
          </div>

          <div className="specifications-section">
            <h3>Caratteristiche Tecniche</h3>
            <table className="specs-table">
              <tbody>
                {Object.entries(product.specifications).map(([key, value]) => (
                  <tr key={key}>
                    <td className="spec-key">
                      {key.charAt(0).toUpperCase() + key.slice(1)}:
                    </td>
                    <td className="spec-value">{value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="shipping-info">
            <div className="shipping-item">
              <span className="shipping-icon">📦</span>
              <div>
                <p>Spedizione Veloce</p>
                <small>Consegna in 24-48 ore</small>
              </div>
            </div>
            <div className="shipping-item">
              <span className="shipping-icon">🔒</span>
              <div>
                <p>Pagamento Sicuro</p>
                <small>Transazioni protette</small>
              </div>
            </div>
            <div className="shipping-item">
              <span className="shipping-icon">↩️</span>
              <div>
                <p>Reso Facile</p>
                <small>30 giorni di garanzia</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;